import { clearCookies } from './../../utils/index';
import { Router } from "vue-router";
import Cookies from "js-cookie";
import { App } from "vue";
import Storage from "@/core/services/storage";
let lockr = new Storage("cpms_");
import store from "@/store";
import { message,Modal } from "ant-design-vue";
import { displayAllMenuRoutes } from "@/layout/layout.constant";
import { getMenus } from "@/views/login/login.menus";

// import { analysInfo } from "@/core/yiguan-sdk";
export const whiteList = [
  "/",
  "/login",
  "/login2",
  "/join",
  "/joinh5",
  "/mobileCode",
  "/setPassword",
  "/errorPage",
  "/successPage",
  "/inspectionPage",
  "/inspectionDetail",
  "/trial",
  "/no-access",
  "/version",
  "/userinfo",
  "/VideoIntroducePage",
  "/train/VideoIntroducePage",
  "/versionDetailH5",
  "/versionDetail",
  "/nVersionDetail",
  "/miniatureVersionDetail",
  "/miniatureVersionDetailH5",
  "/allVersionDetail",
  "/productDetail",
  "/filePreview",
  "/personal-workbench",
  "/message-center",
  "/dashboard/viewNews/detail",
  "/dashboard/enterpriseAnnouncement/detail",
  "/dashboard/list/enterpriseAnnouncement",
  "/dashboard/list/rulesAndRegulations",
  "/dashboard/rulesAndRegulations/detail",
  "/dashboard/detail/companyNoticeDetails",
  "/sign-link",
  "/zhihuixinghejlb",
  "/maintenanceAcceptance",
  "/project/general-add",
  "/platform-electronic-visa/signature/signlink",
  "/platform-electronic-visa/signature/sign-mobile",
  "/platform-electronic-visa/signature/sign-mobile-complete",
  "/platform-electronic-visa/signature/sign-complete",
  "/platform-electronic-visa/popularizeLink",
  "/contract/profile/ocr-create"
];
export function setupRouterGuards(router: Router, app: App) {
  router.beforeEach(async (to, from, next) => {
    if(window.top!==window.self){//在iframe时
      if(!to.query['clear']){
        to.query={
          ...to.query,
          ...from.query
        }
        to.query['clear']=null
      }
      // if(to.path?.indexOf('/create')>-1){//在项目360视图中，点击新建时，把上面的概览收起
      //   window.parent.postMessage({ type: 'setShowCard', data: false }, '*');
      // }      
    }
    // if (from.path === "/" && to.path === "/no-access") {
    //   next("/dashboard?source=fromNoAccess");
    // } else {
      console.log("to.path", to);
      if (whiteList.includes(to.path)) {
        if (displayAllMenuRoutes.includes(to.path)) {
          await getMenus(to, false);
          store.commit("user/SET_activeFirstMenu", { menuId: -1 });
        }
        next();
      } else if (
        to.path.startsWith("/dashboard/viewNews/detail") ||
        to.path.startsWith("/dashboard/enterpriseAnnouncement/detail") ||
        to.path.startsWith("/dashboard/rulesAndRegulations/detail") ||
        to.path.startsWith("/dashboard/detail/companyNoticeDetails") ||
        to.path.startsWith("/dashboard/list/rulesAndRegulations") ||
        to.path.startsWith("/dashboard/list/enterpriseAnnouncement")
      ) {
        next();
      } else {
        const accessToken = Cookies.get("at");
        if (accessToken) {
          let fullPath = to.fullPath;
          // let pathDeep = fullPath.split("/").reduce((o, cur) => {
          //   if (cur.length > 0) {
          //     o.push(cur);
          //   }
          //   return o;
          // }, [] as Array<string>).length;
          // console.log(
          //   "原生fullpath,from:",
          //   from.fullPath,
          //   ";to:",
          //   to.fullPath,
          //   fullPath.split("/")
          // );

          let originalMenuObj = store.state.user.originalMenuObj;
          // let originalMenuObj = lockr.get("originalMenuObj");
          if (!originalMenuObj[fullPath]) {
            await getMenus(to, false);
            originalMenuObj = store.state.user.originalMenuObj;
          }
          if (!originalMenuObj[fullPath]) {
            //这种是针对详情或者编辑的路由，详情和编辑的路由最后一层是id，id不同会导致路由不同，所以这里把id截取掉
            let paramskeys = Object.keys(to.params) || [];
            let queryKeys = Object.keys(to.query) || [];
            if (paramskeys.length > 0) {
              let index = fullPath.lastIndexOf("/");
              if (index > 0) {
                fullPath = fullPath.substring(0, index);
              }
            }
            if (queryKeys.length > 0) {
              if (fullPath.indexOf("?") > 0) {
                fullPath = fullPath.substring(0, fullPath.indexOf("?"));
              }
            }
          }
          // console.log("导航守卫：", originalMenuObj, fullPath, to.fullPath);
          console.log("router guards", originalMenuObj, fullPath, to.fullPath);
          if (!originalMenuObj[fullPath]) {
            if (from.path === "/" && (to.path === "/dashboard" || to.path ==='/platform-electronic-visa/workbench')) {
              clearCookies()
              lockr.flush();
              next("/login");
              clearCookies()

            } else {
              next("/no-access");
            }
          } else {
            next();
          }
        } else {
          clearCookies()
          next({ path: "/login" });
          clearCookies()
        }
      }
    // }
  });

  router.afterEach((to, from, failure) => {
    document.title = (to?.meta?.title as string) || document.title;
    // const AnalysysAgent = analysInfo.AnalysysAgent as any;

    // AnalysysAgent?.pageView(document.title);
  });
  router.onError((error) => {
    console.log(error, "路由错误");
  });
}

export function setupRouterAuthentication(router: Router, app: App) {
  router.beforeEach((to, from, next) => {
    // 费用中心校验权限
    // 所有包含 expense 的路由都需要判断实名认证
    if (to.path.includes("/expense")) {
      const user = store.state.user;
      if (user.authUserStatus != 2) {
        personageModal()
        // next({ path: "/not-verified", query: { type: "1" } });
        return;
      }
      if (user.authCompanyStatus != 4) {
        enterpriseModal()
        // next({ path: "/not-verified", query: { type: "2" } });
        return;
      }
    }
    // 签署校验权限
    if (to.path.includes("/platform-electronic-visa/signature") && !whiteList.includes(to.path)) {
      const user = store.state.user;
      if (user.authUserStatus != 2) {
        personageModal()
        return;
      }
      if (user.authCompanyStatus != 4) {
        enterpriseModal()
        return;
      }
    }
    // 授权校验权限
    if (to.path.includes("/organization/auth-seal/list")) {
      const user = store.state.user;
      if (user.authUserStatus != 2) {
        personageModal()
        return;
      }
      if (user.authCompanyStatus != 4) {
        enterpriseModal()
        return;
      }
    }
    next();
  });
}

const goRenZheng = (type) => {
  const userInfo = store.state.user.userInfoAccessToken.userResp
  const ownerCompany = userInfo.company;
  const tenantId = userInfo.tenantId;
  const userId = userInfo.tenantUserId;
  window.open(
    `/platform-electronic-visa/signature/signlink?companyType=${type}&ownerCompany=${ownerCompany}&tenantId=${tenantId}&userId=${userId}`
  );
};
const personageModal = ()=>{
  Modal.warning({
    title: "提示",
    content: "当前登录人未完成实名认证，请前往",
    okText: `前往个人认证`,
    closable: true,
    onOk: async () => goRenZheng(1),
  });
}
const enterpriseModal = ()=>{
  Modal.warning({
    title: "提示",
    content: "当前租户企业未完成实名认证，请前往,成功认证后赠送5份免费签署额度",
    okText: `前往企业认证`,
    closable: true,
    onOk: async () => goRenZheng(2),
  });
}

